var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "organization-tree-container" },
    [
      _c("el-input", {
        staticStyle: { "margin-bottom": "10px" },
        attrs: { placeholder: "搜索分类", "prefix-icon": "el-icon-search" },
        model: {
          value: _vm.filterText,
          callback: function($$v) {
            _vm.filterText = $$v
          },
          expression: "filterText"
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "tips" }, [
        _vm._v("温馨提示：树形可通过鼠标右键维护")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tree" },
        [
          _c("el-tree", {
            ref: "baseTree",
            staticClass: "treeShow",
            attrs: {
              data: _vm.treeData,
              props: _vm.defaultProps,
              "node-key": "id",
              "highlight-current": true,
              "expand-on-click-node": true,
              "filter-node-method": _vm.filterNode,
              "default-expanded-keys": _vm.selectedNodeList,
              draggable: "",
              "auto-expand-parent": false,
              accordion: false
            },
            on: { "node-contextmenu": _vm.rihgtClick, "node-click": _vm.getId },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var node = ref.node
                    var data = ref.data
                    return _c("span", { staticClass: "slot-t-node" }, [
                      _c("span", [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  data.children && data.children.length >= 1,
                                expression:
                                  "data.children && data.children.length >= 1"
                              }
                            ]
                          },
                          [
                            data.resolve_type !== "2"
                              ? _vm._t("ruleIcon")
                              : _vm._e(),
                            _vm._v(" "),
                            data.resolve_type === "2"
                              ? _vm._t("flowIcon")
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  data.id >= _vm.maxexpandId
                                    ? "slot-t-node--label"
                                    : ""
                                ],
                                attrs: { id: "show-ellipsis", title: data.name }
                              },
                              [_vm._v(_vm._s(data.name || data.system_name))]
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !data.children || data.children.length == 0,
                                expression:
                                  "!data.children|| data.children.length == 0"
                              }
                            ]
                          },
                          [
                            data.resolve_type !== "2"
                              ? _vm._t("ruleIcon")
                              : _vm._e(),
                            _vm._v(" "),
                            data.resolve_type === "2"
                              ? _vm._t("flowIcon")
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                class: [
                                  data.id >= _vm.maxexpandId
                                    ? "slot-t-node--label"
                                    : ""
                                ],
                                attrs: { id: "show-ellipsis", title: data.name }
                              },
                              [_vm._v(_vm._s(data.name || data.system_name))]
                            )
                          ],
                          2
                        )
                      ])
                    ])
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("menu", null, { menuVisible: _vm.menuVisible, data: _vm.DATA })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba886af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba886af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BaseTree/BaseTree.vue
// module id = null
// module chunks = 